import { memo, ReactNode } from 'react';

import styles from './WebinarOverview.module.scss';

interface IWebinarOverviewProps {
  image: string;
  title: string;
  subtitle: string;
  children?: ReactNode;
}

const WebinarOverview = ({ image, title, subtitle, children }: IWebinarOverviewProps) => {
  return (
    <div className={styles.webinarOverviewWrapper}>
      <img src={image} alt="webinar-overview" className={styles.webinarOverviewImage} />
      <h2 className={styles.webinarOverviewtitle}>{title}</h2>
      <p className={styles.webinarOverviewSubtitle}>{subtitle}</p>

      <div>{children}</div>
    </div>
  );
};

export default memo(WebinarOverview);
